__turbopack_context__.v({
  "caseSlide": "style-module-scss-module__fNTMmG__caseSlide",
  "hideDefaultCursor": "style-module-scss-module__fNTMmG__hideDefaultCursor",
  "title": "style-module-scss-module__fNTMmG__title",
});
